import { defineStore } from 'pinia';

/** 最大保留条数 */
const MAX_COUNT = 20;

export const useHistoryGoodsStore = defineStore({
  id: 'historyGoods',
  state: (): { items: any[] } => ({
    items: [],
  }),
  getters: {
    /** 按查看时间倒序排列，最新的在最前面 */
    sortedItems(): any[] {
      return [...this.items].sort((a, b) => Number(b.createTime) - Number(a.createTime));
    },
  },
  actions: {
    /**
     * 添加一条足迹记录
     * - 已存在相同 id 时先移除旧记录
     * - 新增记录插入到最前面
     * - 超出最大条数时截断
     */
    addItem(item: any) {
      const idx = this.items.findIndex((i: any) => String(i.id) === String(item.id));
      if (idx !== -1) this.items.splice(idx, 1);
      this.items.unshift({ ...item });
      if (this.items.length > MAX_COUNT) {
        this.items = this.items.slice(0, MAX_COUNT);
      }
    },

    /** 删除指定 id 的足迹 */
    removeItem(id: number | string) {
      const idx = this.items.findIndex((i: any) => String(i.id) === String(id));
      if (idx !== -1) this.items.splice(idx, 1);
    },

    /** 批量删除指定 id 的足迹 */
    removeItems(ids: (number | string)[]) {
      const idSet = new Set(ids.map(String));
      this.items = this.items.filter((i: any) => !idSet.has(String(i.id)));
    },

    /** 清空所有足迹 */
    clearAll() {
      this.items = [];
    },
  },
  persist: true,
});
